import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MuiTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Tooltip from '@mui/material/Tooltip';

export type DriverTableData = {
	name: string;
	mainDriver: boolean;
	isProposer: boolean;
}[];

const Table = styled(MuiTable)(({ theme }) => ({
	tableLayout: 'fixed',
	'& th, td': {
		padding: '16px 0.5rem',
		borderRight: `1px solid ${theme.palette.grey[300]}`,
		textAlign: 'center',
		'&:first-of-type': {
			textAlign: 'left',
		},
		'&:last-of-type': {
			borderRight: 0,
		},
	},
}));

interface DriverTableProps {
	data: DriverTableData;
	disabled: boolean;
	onEditClick: (index: number) => void;
	onRemoveClick: (index: number) => void;
	onMainClick: (index: number) => void;
}

const DriverTable = ({ data, disabled, onEditClick, onRemoveClick, onMainClick }: DriverTableProps) => (
	<Box
		sx={(theme) => ({
			width: '100%',
			border: `1px solid ${theme.palette.grey[300]}`,
			borderRadius: '8px',
			overflowX: 'hidden',
		})}
	>
		<Table>
			<TableHead>
				<TableRow>
					<TableCell>Drivers</TableCell>
					<TableCell>Options</TableCell>
					<TableCell>Main Driver</TableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{data.map((row, index) => (
					<TableRow key={index}>
						<TableCell>{row.name}</TableCell>
						<TableCell>
							<Tooltip title='Edit'>
								<IconButton
									color='primary'
									data-testid={`edit-driver-${index}`}
									disabled={disabled}
									onClick={() => {
										onEditClick(index);
									}}
								>
									<EditIcon />
								</IconButton>
							</Tooltip>
							{/* Only remove additional drivers */}
							{!row.isProposer && (
								<Tooltip title={disabled ? 'Cannot remove a driver while editing.' : 'Remove driver'}>
									<IconButton
										color='primary'
										data-testid={`remove-driver-${index}`}
										disabled={disabled}
										onClick={() => {
											onRemoveClick(index);
										}}
									>
										<DeleteIcon />
									</IconButton>
								</Tooltip>
							)}
						</TableCell>
						<TableCell>
							{row.mainDriver ? (
								<Tooltip title='Main Driver'>
									<CheckCircleIcon fontSize='large' color='primary' />
								</Tooltip>
							) : (
								<Tooltip title='Set Main Driver'>
									<IconButton
										disabled={disabled}
										sx={{ padding: 0 }}
										data-testid={`set-main-driver-${index}`}
										onClick={() => {
											onMainClick(index);
										}}
									>
										<CircleOutlinedIcon fontSize='large' />
									</IconButton>
								</Tooltip>
							)}
						</TableCell>
					</TableRow>
				))}
			</TableBody>
		</Table>
	</Box>
);

export default DriverTable;
